import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Brands } from '@app/core/models/brands.model';
import { ApiService } from '@app/core/services/api.service';

/**
 * BrandsService
 */
@Injectable({ providedIn: 'root' })
export class BrandsService {
  /**
   * url
   */
  public url;

  /**
   * constructor
   * @param {ApiService} apiService
   * @param {HttpClient} http
   */
  constructor(
    private apiService: ApiService,
  ) {}

  /**
   * getBrands
   * @returns {Observable<Brands>}
   */
  getBrands(programKey: string): Observable<Brands> {
    const options = {
      headers: {
        programKey
      },
    };
    return this.apiService.get('/brands', options);
  }

  /**
   * getPatientBrands
   * @returns {Observable<Brands>}
   */
  getPatientBrands(code: string): Observable<Brands> {
    return this.apiService.get(`/brands/${code}`);
  }
}
